import { useContext, useEffect } from "react";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import axiosConfig from "../config/axiosConfig";

/**
 * ProtectedLayout - Protects routes from unauthenticated access.
 * - Checks sessionStorage (instant, client-side)
 * - Also verifies the session cookie with the server on every mount.
 *   If the cookie has expired the backend returns 401 → axiosConfig
 *   interceptor fires → sessionStorage is cleared → user is redirected to /login.
 */
const ProtectedLayout = () => {
  const { currentUser, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/dashboard')) {
      return;
    }

    // Verify the session is still valid with the server.
    // Uses an endpoint that requires auth — any 401 triggers the global interceptor.
    axiosConfig.get('/company/onboarding-status').catch((err) => {
      if (err.response?.status === 401 || err.response?.data?.statuscode === 401) {
        // Clear React state immediately so UI doesn't show stale data
        logout();
        navigate('/login', { replace: true });
      }
    });
  }, [location.pathname, logout, navigate]);

  // Instant client-side gate — sessionStorage cleared by logout() or axiosConfig
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedLayout;
